import { BorderImageModel } from '@sosocio/creator/interfaces';
import ApiService from 'services/ApiService';

class BorderImageService extends ApiService<BorderImageModel> {
	constructor() {
		super('borderimage');
	}
}

export default new BorderImageService();
